import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import Email from "@/components/Email";
import { CONTACT } from "@/constants/testIds";

const SOCIALS = [
  { href: "https://www.instagram.com/forte2space/", label: "Instagram", Icon: Instagram, test: "footer-social-instagram" },
  { href: "https://www.linkedin.com/company/forte2space/", label: "LinkedIn", Icon: Linkedin, test: "footer-social-linkedin" },
];

export default function Footer() {
  return (
    <footer className="border-t border-[color:var(--f2-border)] bg-[color:var(--f2-bg)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="w-6 h-6 border border-[color:var(--f2-saffron)] flex items-center justify-center">
              <span className="w-2 h-2 bg-[color:var(--f2-saffron)]" />
            </span>
            <span className="font-display font-black tracking-tight text-lg">
              FORTE<sup className="saffron">2</sup> SPACE
            </span>
          </div>
          <p className="mt-4 text-sm text-[color:var(--f2-muted)] max-w-md leading-relaxed">
            India&apos;s first career-readiness and capability-mapping platform for the space economy.
            Aligned to the Indian Space Policy 2023 and IN-SPACe&apos;s 2033 decadal vision.
          </p>
          <div className="mt-6 label-xs">Contact</div>
          <Email
            data-testid={CONTACT.supportEmail}
            className="saffron text-base hover:underline"
          />

          <div className="mt-6 label-xs">Follow</div>
          <div className="mt-3 flex items-center gap-3">
            {SOCIALS.map(({ href, label, Icon, test }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={test}
                className="w-10 h-10 border border-[color:var(--f2-border)] flex items-center justify-center hover:border-[color:var(--f2-saffron)] hover:text-[color:var(--f2-saffron)] transition-colors"
              >
                <Icon className="w-4 h-4" strokeWidth={1.75} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="label-xs mb-4">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:saffron">Home</Link></li>
            <li><Link to="/jobs" className="hover:saffron">Marketplace</Link></li>
            <li><Link to="/learning" className="hover:saffron">Learning</Link></li>
            <li><Link to="/mentors" className="hover:saffron">Mentors</Link></li>
            <li><Link to="/contact" data-testid={CONTACT.contactLink} className="hover:saffron">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-xs mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" data-testid={CONTACT.termsLink} className="hover:saffron">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" data-testid={CONTACT.privacyLink} className="hover:saffron">Privacy Policy</Link></li>
            <li><Link to="/refund" data-testid={CONTACT.refundLink} className="hover:saffron">Refund Policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[color:var(--f2-border)]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="label-xs text-[color:var(--f2-muted)]" data-testid={CONTACT.parentCompany}>
            Forte<sup className="saffron">2</sup> Space is a part of{" "}
            <span className="text-white">Gritly Analytics Private Limited</span> · Chennai, India
          </div>
          <div className="label-xs text-[color:var(--f2-muted)]">
            © {new Date().getFullYear()} · All rights reserved · DPDP-aware
          </div>
        </div>
      </div>
    </footer>
  );
}
